var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"c-table-data-cell",class:[{ 'tw-whitespace-nowrap': !_vm.wrapText }, _vm.variant],style:(_vm.gridArea ? { gridArea: _vm.gridArea } : undefined),attrs:{"colspan":_vm.cols}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }